import type { MatchRepository } from '@texas42/app-model';
import type { FlashMessage, RouteLocation } from './router.js';

export interface GuardResult {
  location: RouteLocation;
  flash?: FlashMessage;
}

export async function resolveRouteGuards(
  location: RouteLocation,
  matches: MatchRepository,
): Promise<GuardResult> {
  if (location.name === 'not-found') {
    return {
      location: { name: 'home', params: {}, path: '/', query: {} },
      flash: {
        title: 'Page not found',
        description: "That page doesn't exist.",
        variant: 'warning',
      },
    };
  }

  if (location.name === 'game') {
    const { matchId } = location.params;
    const match = await matches.get(matchId);

    if (!match) {
      return {
        location: { name: 'home', params: {}, path: '/', query: {} },
        flash: {
          title: 'Game not found',
          description: 'We could not find that saved match on this device.',
          variant: 'warning',
        },
      };
    }

    if (match.status === 'completed') {
      return {
        location: {
          name: 'game-summary',
          params: { matchId },
          path: `/game/${matchId}/summary`,
          query: location.query,
        },
      };
    }
  }

  if (location.name === 'replay') {
    const { matchId } = location.params;
    const match = await matches.get(matchId);

    if (!match) {
      return {
        location: { name: 'saved-games', params: {}, path: '/saved-games', query: {} },
        flash: {
          title: 'Replay unavailable',
          description: 'That saved match is missing or damaged.',
          variant: 'warning',
        },
      };
    }
  }

  return { location };
}
